module.exports = __webpack_public_path__ + "img/30.b54f4233.jpg";